import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AcSliderComponent} from './ac-slider.component';
import {Ng5SliderModule} from 'ng5-slider';
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {InfraPipesModule} from "../../pipes/infra.pipes.module";

@NgModule({
    imports: [
        CommonModule,
        Ng5SliderModule,
        FormsModule,
        MatSlideToggleModule,
        FormsModule,
        InfraPipesModule
    ],
    declarations: [
        AcSliderComponent,
    ],
    entryComponents: [
        AcSliderComponent,
    ],
    exports: [
        AcSliderComponent,
    ]
})
export class AcSliderModule {
}
